import React, {useState} from 'react';
import {IonContent, IonPage, IonRouterOutlet} from '@ionic/react';
import {helpCircleOutline} from 'ionicons/icons';
import {Route, RouteComponentProps} from 'react-router-dom';
import {Keyboard, KeyboardResize} from '@capacitor/keyboard';
import {Capacitor} from '@capacitor/core';
import UIBackButton from '../components/UICommon/UIBackButton';
import UIHeading from '../components/UICommon/UIHeading';
import OwnDeclarationPage from './OwnDeclarationPage';
import AddFillTextQuestionPage from './AddFillTextQuestionPage';
import AddTextQuestionPage from './AddTextQuestionPage';
import AddBooleanQuestionPage from './AddBooleanQuestionPage';
import EditTextQuestionPage from './EditTextQuestionPage';
import EditFillTextQuestionPage from './EditFillTextQuestionPage';
import EditBooleanQuestionPage from './EditBooleanQuestionPage';

const OwnDeclarationRouting: React.FC<RouteComponentProps> = ({match}) => {
  const desc = 'Här kan du skapa egna fält i hälsodeklarationen. Dem kommer synas i slutet av hälsodeklarationen.';
  const [isKeyboard, setKeyboard] = useState(0);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

  if (Capacitor.isNativePlatform()) {
    Keyboard.setResizeMode({
      mode: KeyboardResize.None,
    });
    Keyboard.addListener('keyboardWillShow', (info) => {
      document?.activeElement?.scrollIntoView(true);
      setKeyboard(info.keyboardHeight);
      setIsKeyboardOpen(true);
    });

    Keyboard.addListener('keyboardWillHide', () => {
      setKeyboard(0);
      setIsKeyboardOpen(false);
    });
  }

  return (
    <IonPage className='bg-white'>
      <IonContent scrollY={isKeyboardOpen}>
        <div className='h-[10%] md:h-auto'>
          <UIBackButton title='Egen hälsodeklaration' href='/home'
            style={`px-5 pt-5 md:pt-0 md:absolute md:top-4 ${location.pathname === '/egen-deklaration' && 'md:hidden'}`}
          />
          <div className='hidden md:block pt-6'>
            <UIHeading
              style="px-6"
              title="Egen hälsodeklaration"
              description={desc}
              icon={helpCircleOutline}
              big={true}
              date={true}
              longer={true}/>
          </div>
        </div>
        <div className={`md:mt-2 h-[90%] relative px-6 ${isKeyboardOpen ? 'overflow-y-scroll' : ''}`}>
          <IonRouterOutlet>
            <Route exact={true} path={`/egen-deklaration`}>
              <OwnDeclarationPage />
            </Route>
            <Route path={`/egen-deklaration/fylla-text`}>
              <AddFillTextQuestionPage />
            </Route>
            <Route path={`/egen-deklaration/endast-text`}>
              <AddTextQuestionPage />
            </Route>
            <Route path={`/egen-deklaration/checkbox-fraga`}>
              <AddBooleanQuestionPage />
            </Route>
            <Route path={`/egen-deklaration/:id/fylla-text`}>
              <EditFillTextQuestionPage />
            </Route>
            <Route path={`/egen-deklaration/:id/endast-text`}>
              <EditTextQuestionPage />
            </Route>
            <Route path={`/egen-deklaration/:id/checkbox-fraga`}>
              <EditBooleanQuestionPage />
            </Route>
          </IonRouterOutlet>
        </div>
        {isKeyboardOpen && <div style={{height: isKeyboard - 100}}></div>}
      </IonContent>
    </IonPage>
  );
};

export default OwnDeclarationRouting;
